import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getDefaultPathForUser, userCanAccessPanelPath } from '../config/panelRoutes';

/**
 * Pierwsza dozwolona zakładka (wg roli legacy lub panel_allowed_routes).
 */
export default function RoleBasedRedirect() {
  const { user } = useAuth();
  return <Navigate to={getDefaultPathForUser(user)} replace />;
}

/**
 * Dostęp do pojedynczej ścieżki panelu: admin — wszystko; pozostali — wg listy / legacy roli.
 */
export function RequirePanelRoute({ path, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (userCanAccessPanelPath(user, path)) return children;
  return <Navigate to={getDefaultPathForUser(user)} replace />;
}

/** @deprecated Użyj getDefaultPathForUser(user) gdy masz obiekt użytkownika z sesji. */
export function getDefaultPathForRole(role) {
  return getDefaultPathForUser({ role, panel_allowed_routes: null });
}
